import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Grid,
  Card,
  CardContent,
  Collapse,
  IconButton
} from "@mui/material";
import {
  Email,
  Phone,
  LocationOn,
  ExpandMore,
  ExpandLess
} from "@mui/icons-material";
import styles from "./ContactUs.module.scss";
import emailjs from "emailjs-com";
import NavigationBar from "../NavigationBar/NavigationBar";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ContactUs = () => {
  const [showAddress, setShowAddress] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
    subject: ""
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const isFormValid = () => {
    return formData.name && formData.email && formData.message;
  };

  function toCamelCase(str) {
    return str
      .replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, (match, index) =>
        index === 0 ? match.toUpperCase() : match.toLowerCase()
      )
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    const templateParams = {
      from_name: toCamelCase(formData.name),
      message: toCamelCase(formData.message),
      subject: toCamelCase(formData.subject),
      from_email: formData.email,
    };

    emailjs
      .send("service_6a3qqkd", "template_q05t7jn", templateParams, "VlQgZLk0aCY2mRr_p")
      .then(
        (result) => {
          console.log(result.text);
          toast.success("Message sent successfully!");
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        },
        (error) => {
          console.log(error.text);
          toast.error("Failed to send message.");
        }
      );
  };

  return (
    <div className={styles.contactUsContainer}>
      <ToastContainer />
      <NavigationBar />

      <div
        style={{
          maxWidth: 800,
          marginTop: "120px",
          marginBottom: "100px",
          marginLeft: "auto",
          marginRight: "auto"
        }}
      >
        <Typography
          variant="h4"
          gutterBottom
          sx={{ fontWeight: "bold", textAlign: "center", color: "#fff" }}
        >
          Contact Us
        </Typography>

        <Typography
          variant="subtitle1"
          gutterBottom
          sx={{ textAlign: "center", mb: 3, color: "#fff" }}
        >
          We would love to hear from you! Please reach out using the details
          below or fill out the form.
        </Typography>

        <Grid container spacing={2} sx={{ mb: 4 }}>
          <Grid item xs={12} md={4}>
            <Card
              sx={{ backgroundColor: "rgba(255, 255, 255, 0.1)", boxShadow: 3 }}
            >
              <CardContent sx={{ textAlign: "center", minHeight: "95px", cursor: "pointer" }}>
                <LocationOn sx={{ fontSize: 40, color: "#fff" }} />
                <Typography
                  variant="h6"
                  sx={{ fontWeight: "bold", color: "#fff" }}
                >
                  Address
                  <IconButton
                    onClick={() => setShowAddress(!showAddress)}
                    sx={{ color: "#fff" }}
                  >
                    {showAddress ? <ExpandLess /> : <ExpandMore />}
                  </IconButton>
                </Typography>

                <Collapse in={showAddress}>
                  <Typography
                    variant="body2"
                    sx={{ color: "#fff", fontSize: "0.75rem" }}
                  >
                    Endroza Games Private Limited
                    <br />
                    A-104, Uber Verdant Phase-2,
                    <br />
                    Sarjapur Main Road Carmelaram
                    <br />
                    Bangalore South, Bangalore,
                    <br />
                    Karnataka-560035
                  </Typography>
                </Collapse>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={4}>
            <Card
              sx={{ backgroundColor: "rgba(255, 255, 255, 0.1)", boxShadow: 3 }}
            >
              <CardContent sx={{ textAlign: "center", cursor: "pointer" }}>
                <Email sx={{ fontSize: 40, color: "#fff" }} />
                <Typography
                  variant="h6"
                  sx={{ fontWeight: "bold", color: "#fff" }}
                >
                  Email
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: "#fff", fontSize: "0.75rem" }}
                >
                  support@troak.club
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={4}>
            <Card
              sx={{ backgroundColor: "rgba(255, 255, 255, 0.1)", boxShadow: 3 }}
            >
              <CardContent sx={{ textAlign: "center", cursor: "pointer" }}>
                <Phone sx={{ fontSize: 40, color: "#fff" }} />
                <Typography
                  variant="h6"
                  sx={{ fontWeight: "bold", color: "#fff" }}
                >
                  Phone
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: "#fff", fontSize: "0.75rem" }}
                >
                  +91 90165 52897
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        <Typography
          variant="h5"
          gutterBottom
          sx={{ fontWeight: "bold", mb: 2, color: "#fff" }}
        >
          Get in Touch
        </Typography>

        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            padding: 4,
            boxShadow: 3,
            backgroundColor: "rgba(255, 255, 255, 0.1)",
            borderRadius: "10px"
          }}
        >
          <TextField
            name="name"
            value={formData.name}
            onChange={handleChange}
            variant="outlined"
            sx={{
              backgroundColor: "rgba(255, 255, 255, 0.1)",
              borderRadius: "10px",
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#fff"
                },
                "&:hover fieldset": {
                  borderColor: "#fff"
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#fff"
                },
                input: { color: "#fff" },
                textarea: { color: "#fff" }
              }
            }}
            label="Your Name"
            fullWidth
            required
            InputLabelProps={{
              style: { color: "#fff" }
            }}
          />
          <TextField
            name="email"
            value={formData.email}
            onChange={handleChange}
            label="Your Email"
            type="email"
            variant="outlined"
            sx={{
              background: "rgba(255, 255, 255, 0.1)",
              borderRadius: "10px",
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#fff"
                },
                "&:hover fieldset": {
                  borderColor: "#fff"
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#fff"
                },
                input: { color: "#fff" },
                textarea: { color: "#fff" }
              }
            }}
            fullWidth
            required
            InputLabelProps={{
              style: { color: "#fff" }
            }}
          />
          <TextField
            name="subject"
            value={formData.subject}
            onChange={handleChange}
            label="Subject"
            variant="outlined"
            sx={{
              background: "rgba(255, 255, 255, 0.1)",
              borderRadius: "10px",
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#fff"
                },
                "&:hover fieldset": {
                  borderColor: "#fff"
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#fff"
                },
                input: { color: "#fff" },
                textarea: { color: "#fff" }
              }
            }}
            fullWidth
            required
            InputLabelProps={{
              style: { color: "#fff" }
            }}
          />
          <TextField
            name="message"
            value={formData.message}
            onChange={handleChange}
            label="Your Message"
            variant="outlined"
            sx={{
              background: "rgba(255, 255, 255, 0.1)",
              borderRadius: "10px",
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#fff"
                },
                "&:hover fieldset": {
                  borderColor: "#fff"
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#fff"
                },
                background: "rgba(255, 255, 255, 0.1)",
                input: { color: "#fff" },
                textarea: { color: "#fff" }
              }
            }}
            multiline
            rows={4}
            fullWidth
            required
            InputLabelProps={{
              style: { color: "#fff" }
            }}
          />
          <Button
            type="submit"
            variant="contained"
            color="secondary"
            size="large"
            sx={{
              alignSelf: "flex-start",
              color: "#fff",
              backgroundColor: "#ff4081",
              "&:hover": {
                backgroundColor: "#f50057"
              }
            }}
            disabled={!isFormValid()}
          >
            Submit
          </Button>
        </Box>
      </div>
    </div>
  );
};

export default ContactUs;
